/**
 * SubTheme entity class
 */

/**
 * SubThemeFactory
 * returns SubTheme entity class
 *
 * @class SubThemeFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SubTheme} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SubThemeFactory
 */
/* @ngInject */
export default function SubThemeFactory (Entity) {
  /* === SubTheme class === */

  /**
   * SubTheme model
   *
   * @class SubTheme
   * @classdesc SubTheme model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing SubTheme entity fields
   * @return {models.SubTheme} SubTheme entity
   */
  function SubTheme () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SubTheme.prototype = Object.create(Entity.prototype)
  SubTheme.prototype.constructor = SubTheme

  /* === SubTheme instance methods & fields === */

  Object.assign(SubTheme.prototype, {

    /**
     * instance fields
     *
     * @memberof models.SubTheme#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      themes: ['Theme']
    }

  })

  /* === SubTheme static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(SubTheme, Entity)
  SubTheme._name = 'SubTheme'
  SubTheme.init()

  return SubTheme
}
